export default {
  getBaseAddress(state) {
    return state.base_address;
  },

  getWebSiteAddress(state) {
    return state.website_address;
  },

  getIndexToShow(state) {
    return state.index_to_show;
  },

  configs(state) {
    if (state.configs.lenght <= 0) {
      state.configs = JSON.parse(localStorage.getItem("configs")) || [];
    }
    return JSON.parse(localStorage.getItem("configs")) || [];
  },

  urlToCV(state) {
    return function (anno, numero) {
      // console.log("anno, numero")
      // console.log(anno, numero)
      const urlToPrenotazioneCV = state.urlToPrenotazioneCV;
      // console.log("urlToPrenotazioneCV")
      // console.log(urlToPrenotazioneCV)
      // console.log("idTemp=0&annoPratica=anno&numeroPratica=numero")
      // console.log(urlToPrenotazioneCV + "idTemp=0&annoPratica=" + anno + "&numeroPratica=" + numero)
      return (
        urlToPrenotazioneCV +
        "idTemp=0&annoPratica=" +
        anno +
        "&numeroPratica=" +
        numero
      );
    };
  },
  getMCEsettings(state) {
    return state.tinyMCEsettings;
  },
};
